import { useAuth } from "../auth/AuthContext";

/**
 * A visually hidden username slot for the browser's credential autofill.
 *
 * Chrome pairs a saved credential with "the text input nearest the password field" and ignores
 * autocomplete="off" while doing it — which is how the account e-mail ended up inside the CLABE
 * field. Giving the form an explicit `autocomplete="username"` input redirects that heuristic:
 * the e-mail lands here, invisibly and read-only, and every visible field keeps its own value.
 * Hidden via the off-screen pattern rather than display:none, which Chrome would skip over.
 */
export function AutofillUsername() {
  const { user } = useAuth();
  return (
    <input
      className="autofill-username"
      type="text"
      name="username"
      autoComplete="username"
      value={user?.email ?? ""}
      readOnly
      tabIndex={-1}
      aria-hidden="true"
    />
  );
}
